const GrowArrow = (props) => (
    <svg {...props} width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.55 9.5L0.5 8.45L4.475 4.475C4.9125 4.0375 5.44375 3.81875 6.06875 3.81875C6.69375 3.81875 7.225 4.0375 7.6625 4.475L8.525 5.3375C8.675 5.4875 8.85313 5.5625 9.05938 5.5625C9.26562 5.5625 9.44375 5.4875 9.59375 5.3375L12.9313 2H11V0.5H15.5V5H14V3.06875L10.6438 6.40625C10.2063 6.84375 9.675 7.0625 9.05 7.0625C8.425 7.0625 7.89375 6.84375 7.45625 6.40625L6.575 5.525C6.4375 5.3875 6.2625 5.31875 6.05 5.31875C5.8375 5.31875 5.6625 5.3875 5.525 5.525L1.55 9.5Z"
            fill={props.fill || '#9D9D9D'}
        />
    </svg>
);

export default GrowArrow;
